var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCircleTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#44837D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4198 38.8714C21.6419 38.0873 20.3756 38.0822 19.5914 38.8602C18.8073 39.6381 18.8022 40.9044 19.5802 41.6886L22.4198 38.8714ZM30.6429 50L29.223 51.4086C29.6317 51.8205 30.1992 52.0347 30.7781 51.9954C31.3571 51.9562 31.8905 51.6674 32.2398 51.2041L30.6429 50ZM52.597 24.2041C53.2619 23.3221 53.086 22.068 52.2041 21.403C51.3221 20.7381 50.068 20.914 49.403 21.7959L52.597 24.2041ZM19.5802 41.6886L29.223 51.4086L32.0627 48.5914L22.4198 38.8714L19.5802 41.6886ZM32.2398 51.2041L52.597 24.2041L49.403 21.7959L29.0459 48.7959L32.2398 51.2041Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCircleTick);
export default __webpack_public_path__ + "static/media/green-circle-tick.d4117fc9.svg";
export { ForwardRef as ReactComponent };